import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MailHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6.989 9.228-3-3m16.022 0-3 3M19 16.038l-2-2m-10 0-2 2m10.964-5.393c.581 2.52-2.41 5.367-2.957 5.493S8.523 15.015 7.941 12.5a2.34 2.34 0 0 1 1.554-2.785 2.14 2.14 0 0 1 2.224.844 2.14 2.14 0 0 1 1.629-1.733 2.34 2.34 0 0 1 2.616 1.82M4.894 5h14.211C20.152 5 21 5.836 21 6.867v10.266C21 18.164 20.152 19 19.105 19H4.895C3.848 19 3 18.164 3 17.133V6.867C3 5.836 3.848 5 4.895 5"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MailHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
